import { styled as r, Button as S } from "@mui/material";
import b from "./ConfirmButton.js";
import k from "./ConfirmPasswordTextField.js";
import B from "./EmailOTPSender.js";
import E from "./OTPCodeTextField.js";
import A from "./PasswordTextField.js";
import I from "./PopupTitle.js";
import j from "../../share/popup/InfoPopup.js";
import { INFO_POPUP_TYPE as M } from "../../../constants/popup.js";
import { useAccountContext as N } from "../../../contexts/account/AccountContext.js";
import { useMessageContext as q } from "../../../contexts/share/MessageContext.js";
import z from "../../../hooks/errors/useErrorHandler.js";
import G from "../../../hooks/graphql/useForgetAccountPassword.js";
import { OTPType as H } from "../../../types/email.js";
import { useState as K, useCallback as p } from "react";
import { useForm as L, useWatch as U } from "react-hook-form";
import { useTranslation as V } from "react-i18next";
import { jsxs as u, Fragment as W, jsx as o } from "react/jsx-runtime";
const Y = r(j)`
  max-width: 600px;
  width: 95%;
`, v = r("form")`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 30px 50px 30px;
  gap: 18px;
`, D = r(I)`
  width: 90%;
  margin-bottom: 10px;
`, J = r(S)`
  color: #3682eb;
  text-transform: none;
  padding-left: 0px;
  font-size: 14px;
  font-weight: 300;
`, wo = (w) => {
  const {
    className: g
  } = w, {
    t
  } = V(), {
    account: x
  } = N(), {
    mutate: i
  } = G(), {
    getErrorMessage: c
  } = z(), {
    setInfo: d,
    showGeneralError: s
  } = q(), {
    control: e,
    handleSubmit: P,
    reset: l,
    trigger: h
  } = L({
    mode: "onChange"
  }), C = U({
    name: "password",
    control: e
  }), [T, f] = K(!1), y = p(() => {
    f(!0);
  }, []), n = p(() => {
    f(!1), l();
  }, [l]), F = p(async (_) => {
    try {
      const {
        email: a,
        otpCode: m,
        password: O
      } = _;
      await i({
        email: a,
        otpCode: m,
        password: O
      }) ? (d({
        message: t("account_setting.password_updated"),
        confirm: t("common.popup.ok")
      }), n()) : s(t("error.graphql.fallback.update_info"));
    } catch (a) {
      const m = c(a);
      s(m);
    }
  }, [i, c, n, d, s, t]);
  return /* @__PURE__ */ u(W, {
    children: [/* @__PURE__ */ o(J, {
      className: g,
      onClick: y,
      children: t("account_setting.forgot_password")
    }), /* @__PURE__ */ o(Y, {
      type: M.BLACK,
      open: T,
      onClose: n,
      children: /* @__PURE__ */ u(v, {
        onSubmit: P(F),
        children: [/* @__PURE__ */ o(D, {
          title: t("account_setting.forgot_password")
        }), /* @__PURE__ */ o(B, {
          control: e,
          defaultValue: x.email,
          name: "email",
          otpType: H.ForgotPassword
        }), /* @__PURE__ */ o(E, {
          name: "otpCode",
          control: e
        }), /* @__PURE__ */ o(A, {
          autoComplete: "new-password",
          control: e,
          name: "password"
        }), /* @__PURE__ */ o(k, {
          autoComplete: "new-password",
          control: e,
          name: "confirmPassword",
          password: C,
          trigger: h
        }), /* @__PURE__ */ o(b, {})]
      })
    })]
  });
};
export {
  wo as default
};
//# sourceMappingURL=ForgotPasswordButton.js.map
